import swal from "@sweetalert/with-react";
import { toastr } from "react-redux-toastr";

export const successAlertMessage = (message) => {
  return swal({
    title: "Success",
    text: message,
    closeOnClickOutside: false,
    closeOnEsc: false,
  });
};

export const confirmBox = async (
  text = "Do you want to delete this record?",
  title = "Are you sure?"
) => {
  const confirmBox = await swal({
    title,
    text,
    icon: "warning",
    dangerMode: true,
    buttons: {
      cancel: {
        text: "No",
        value: false,
        visible: true,
      },
      confirm: {
        text: "Yes",
        value: true,
        visible: true,
      },
    },
    closeOnClickOutside: false,
    closeOnEsc: false,
  });
  return confirmBox;
};

export const toastrMessage = (message, type) => {
  toastr.light(message, {
    status: type,
  });
};
